import { FormAutocomplete, FormAutocompleteProps, FormInput, useAlert, useForm, useGetError } from '@hilma/forms';
import makeStyles from '@material-ui/core/styles/makeStyles';
import parse from 'autosuggest-highlight/parse';
import Grid from '@material-ui/core/Grid';
import axios from 'axios';

import { School } from '../types';

export interface SchoolsAutocompleteProps {
	id: string;
	description: string;
	noOptionsText?: string;
	loading?: boolean;
	classes?: FormAutocompleteProps<School>['classes'];
	disabled?: boolean;
}

const SchoolsAutocomplete: React.FC<SchoolsAutocompleteProps> = ({ id, description, noOptionsText, loading, classes, disabled }) => {

	const form = useForm();
	const alert = useAlert();
	const getError = useGetError();

	const fetchPredictions = async (input: string) => {
		try {
			const { data } = await axios.get<School[]>('/api/school/get-admin-school-select-options', { params: { search: input } });
			return data || [];
		} catch (err: any) {
			console.error(err);
			alert(getError(err));
			return [];
		}
	}

	if (loading) return <FormInput id={id} description={description} loading={true} />

	return (
		<FormAutocomplete
			disabled={disabled}
			id={id}
			classes={classes}
			description={description}
			noOptionsText={noOptionsText || "שם בית הספר"}
			initialValue={form.values[id] || form.values[id].name}
			fetchFunction={fetchPredictions}
			getOptionSelected={(option: School, value: School) => value.id === option.id}
			onChangeOptionsFilter={(newValues: School, options: School[]) => [newValues, ...options.filter(s => s.id != newValues.id)]}
			getOptionLabel={(option) => (typeof option === 'string' ? option : option.name)}
			renderOption={(option, state) => {
				const matches: Array<[number, number]> = [];
				const searchValue = state.inputValue.trim();
				const inputValueIndex = option?.name?.toLowerCase().indexOf(searchValue?.toLowerCase());

				if (inputValueIndex !== -1) {
					matches.push([inputValueIndex, inputValueIndex + searchValue.length]);
				}
				const parts = parse(option?.name?.toString(), matches);

				return (
					//TODO: align to right
					<Grid item>
						{parts.map((part: { text: string; highlight: boolean }, index: number) => (
							<span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>
								{part.text}
							</span>
						))}
					</Grid>
				);
			}}
		/>
	);
}

export default SchoolsAutocomplete

const useStyles = makeStyles(theme => ({

}));
